module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "part01chapter02"
    }
  }), _vm._v("2: TRANSCRIPT,"), _c('br'), _vm._v("“WITNESS” INTERVIEW")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Property of the United States Air Force")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Classification: Secret, Level 8")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Recorded: April 18, 2020")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Interviewee: Camilla Mary O’Kane, ID # 065-453-8765274 [personal data and background check attached]")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Interviewer: Atoner, identity unknown")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Place: Atoner Luna Base")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Recorder: Col. John Karl Stoddard, USAF Intelligence")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Present: Interviewee, Recorder, Atoner behind usual screen, all usual restrictions in place")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("ATONER:")])]), _vm._v(" Good day, Ms. O’Kane.")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O’KANE:")])]), _vm._v(" Good day, sir. [NOTE: DESPITE EXHAUSTIVE PREINTERVIEW BRIEFING, INTERVIEWEE IS RESPONDING COUNTER TO SUGGESTION WITH HONORIFIC CHOICE. ATONER GENDERS REMAIN UNKNOWN.]")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" I hope your flight up to Luna was pleasant.")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O:")])]), _vm._v(" Yes. Your shuttle was smooth and fast. I never flew on a plane before.")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" You have been chosen from a large number of applicants for this interview. Why do you wish to become a Witness?")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O:")])]), _vm._v(" So we’re going to plunge right in? Okay. I’m going to be honest, sir. I’m twenty-three years old and I’ve always held pretty crappy jobs. Right now I’m a waitress. I was smart in high school, but afterward I couldn’t afford college, and the way things are in the United States right now . . . Do you know what I mean by that?")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O:")])]), _vm._v(" The way things are, the best I can get are jobs where I can’t make any decisions or learn anything important or have an impact on anything. And I live in "), _c('em', [_vm._v("Nebraska")]), _vm._v(". I don’t understand why anyone "), _c('em', [_vm._v("wouldn’t")]), _vm._v(" want to be a Witness! Here I am on the moon, something I never dreamed possible for me. And to go to another planet, see a whole different—Haven’t you had applications from all over the world?")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O:")])]), _vm._v(" And that’s only from countries that permit their citizens to apply! I heard that on a podcast. If the repressive countries let their people apply, you’d probably get millions more applications.")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" What do you think are your qualifications to witness for us on another planet?")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O:")])]), _vm._v(" I’m intelligent, strong, and healthy. I’m brave. I don’t rattle easily—I really don’t. I notice everything. And even though I’m not trained or anything, I want to do this so much that I’ll study anything you want, do anything you tell me to.")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" You notice everything?")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O:")])]), _vm._v(" Well, maybe not everything—please don’t hold that statement against me!")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" What would you do if we told you to do something you think is morally wrong?")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O:")])]), _vm._v(" [long silence] Then . . . I guess I wouldn’t do it. Does that disqualify me?")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" No. You say you are intelligent and strong and able to learn well. Why don’t those qualities enable you to create a life better than “crappy”?")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O:")])]), _vm._v(" [long silence] I think—forgive me, sir—that despite what you said before, I think you don’t understand the United States right now. The economy sucks. The environment is going down the toilet. Even rich and educated people are scrambling to stay all right, and for somebody like me . . . You think intelligence and grit can succeed by themselves, but I’m telling you that’s a pretty illusion.")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" Thank you for your interview, Ms. O’Kane.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O:")])]), _vm._v(" What? You mean that’s it? That’s all the time I get? [NOTE: INTERVIEWEE IS STRONGLY ACTING CONTRARY TO PREINTERVIEW BRIEFING.]")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" What more would you like?")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O:")])]), _vm._v(" Can "), _c('em', [_vm._v("I")]), _vm._v(" ask some questions?")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" [long silence] Yes. [NOTE: THIS SILENCE OF 6.3 SECONDS HAS BEEN NOTED IN NO OTHER INTERVIEW RECORDED BY USAF INTELLIGENCE OR BY THOSE COUNTRIES PARTICIPATING IN THE ALIEN DATA-SHARING INITIATIVE.]")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O:")])]), _vm._v(" Why do you want to send human Witnesses to those other planets anyway? You’re the ones with starships, why not go yourselves?")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" We cannot answer that.")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O:")])]), _vm._v(" You mean—and I say this with all due respect, sir—that you choose to not answer it?")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O:")])]), _vm._v(" Well, okay. Then . . . you call yourselves “Atoners.” What are you atoning "), _c('em', [_vm._v("for")]), _vm._v("? [NOTE: STRONGLY ACTING CONTRARY TO PREINTERVIEW BRIEFING. INTERVIEWEE WAS SPECIFICALLY AND REPEATEDLY INSTRUCTED NOT TO ASK THIS, AS A MATTER OF DIPLOMATIC RELATIONS.]")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" Were you told to not ask that question?")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O:")])]), _vm._v(" Well . . . yes.")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" Then why did you ask it, Ms. O’Kane?")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O:")])]), _vm._v(" Because I . . . Oh, fuck, I really blew it, didn’t I? You’re not going to accept me as a Witness. So I don’t have anything to lose, but I still would like to know. Shit, the whole "), _c('em', [_vm._v("world")]), _vm._v(" would like to know! What are you atoning for?")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" We choose to not answer that.")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("O:")])]), _vm._v(" Okay. Your right. Anyway, thank you for the trip up here. I never thought . . . This is something I’ll remember my whole life. And I wish you luck, sir, with your project, whatever it is.")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("A:")])]), _vm._v(" Thank you.")])]), _vm._v(" "), _c('blockquote', [_c('blockquote', [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "60%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxnote"
  }, [_vm._v("DATE: May 16, 2020"), _c('br'), _vm._v("INTERVIEW RESULT: Interviewee"), _c('br'), _vm._v("Accepted")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f1cc42c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01chapter02.vue
// module id = 87
// module chunks = 0